export const tagAuditApplicationTypeEnum = [
    {
        stateId: "CREATE",
        stateName: "创建"
    },
    {
        stateId: "EDIT",
        stateName: "创建重审"
    },
    {
        stateId: "DISABLE",
        stateName: "禁用"
    },
    {
        stateId: "ENABLE",
        stateName: "启用"
    }
]
